"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructuredQuestionTypes = exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType["RADIO"] = "radio";
    QuestionType["NUMBER"] = "number";
    QuestionType["STATE_GEOLOC"] = "state-geoloc";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
exports.StructuredQuestionTypes = [
    QuestionType.STATE_GEOLOC,
];
